import React, { useEffect, useState } from "react";
import { useRouteError } from "react-router-dom";

export const ErrorElement = () => {
  const error = useRouteError();

  const errorType = {
    axios: "AxiosError",
    typeErr: "TypeError",
    referenceErr: "ReferenceError",
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [errorCode, setErrorCode] = useState("");
  const [fix, setFix] = useState("");

  function getErrorMessage() {
    if (error.name === errorType.typeErr) {
      setErrorMessage(error.message);
      setErrorCode("DEV_ERR");
      setFix("Contact support");
    } else if (error.name === errorType.referenceErr) {
      setErrorMessage(error.message);
      setErrorCode("DEV_ERR");
      setFix("Contact support");
    } else if (error.name === errorType.axios) {
      setErrorMessage(error.response.data.message);
      setErrorCode(error.response.status);
      setFix("Contact support");
    } else {
      setErrorMessage("There was an unknown error");
      setErrorCode("UNKNOWN_ERROR");
      setFix("Contact support");
    }
  }

  useEffect(() => {
    getErrorMessage();
  }, [error]);

  return (
    <div className="px-7 py-5">
      <h2 className="text-2xl font-bold">An error occurred</h2>
      <p className="mt-2">
        An unknown error occurred while fetching the information for this page.
      </p>
      {/* <p className="mt-1">Please try reloading.</p> */}

      <div className="mt-4 p-3 border border-red-500 w-[50%] rounded-[8px] bg-red-100">
        <div className="font-semibold text-red-500 text-[14px]">Error logs</div>
        <div className="mt-3 text-[14px] space-y-2 text-red-500">
          <div className="font-medium">
            ERROR_CODE: <span>{errorCode}</span>
          </div>
          <div className="font-medium">
            Message: <span>{errorMessage}</span>
          </div>
          <div className="font-medium">
            Fix: <span>{fix}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
